import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function RefundPolicy() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#fafaf8]" data-testid="refund-policy">
      <div className="sticky top-0 z-10 bg-white/80 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-6 py-3 flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="text-gray-500 hover:text-gray-900"><ArrowLeft size={18} /></button>
          <h1 className="font-semibold text-gray-900">Refund Policy</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-10 prose prose-sm prose-gray">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Super Morsel - Refund Policy</h2>

        <p>At Super Morsel, we strive to deliver the best food experience. If something doesn't meet your expectations, here's how we handle refunds:</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">1. Eligibility for Refund</h3>
        <p className="text-sm text-gray-600">Refunds may be initiated in the following cases:</p>
        <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
          <li>Wrong item delivered.</li>
          <li>Missing items from the order.</li>
          <li>Quality issues (e.g., stale food, packaging damage).</li>
          <li>Order not delivered within the estimated time and no longer needed.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-6 mb-2">2. How to Request a Refund</h3>
        <p className="text-sm text-gray-600">Contact us within 24 hours of delivery with your order ID and a brief description of the issue. Attach photos if applicable.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">3. Refund Process</h3>
        <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
          <li>Approved refunds will be credited to your Super Morsel Wallet within 24-48 hours.</li>
          <li>In case of payment gateway issues, refunds to bank accounts may take 5-7 business days.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-6 mb-2">4. Non-Refundable Scenarios</h3>
        <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
          <li>Change of mind after order confirmation (unless cancelled before preparation).</li>
          <li>Incorrect address provided by the customer.</li>
          <li>Customer unavailable at the time of delivery (after reasonable wait).</li>
        </ul>

        <h3 className="text-lg font-semibold mt-6 mb-2">5. Order Cancellations</h3>
        <p className="text-sm text-gray-600">Orders can be cancelled before they move to preparation. Cancelled orders are automatically refunded to the wallet.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">6. Wallet Refunds</h3>
        <p className="text-sm text-gray-600">Wallet top-ups are non-refundable as cash. Credits remain usable for future orders on supermorsel.com.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">7. Contact Us</h3>
        <p className="text-sm text-gray-600">For refund requests or disputes, email us at <strong>hello@supermorsel.com</strong> or call our support line.</p>

        <p className="text-[10px] text-gray-500 mt-8 border-t pt-4">We're committed to fair practices and making it right. Thank you for choosing Super Morsel — fresh cravings, guilt free, every single meals every day.</p>
      </div>
    </div>
  );
}
